<template>
  <div>
    <form novalidate class="md-layout" @submit.prevent="validateUser">
      <md-card class="md-layout-item md-size-60 md-small-size-100 mx-auto">
        <md-card-header>
          <div v-show="message" v-html="alertMessage" :class="alertClass" class="alert fade show" role="alert"></div>
          <h3 class="mb-4 mt-4 font-weight-bold text-uppercase" v-if="!isTalentOrVenteApp"><strong>{{$t('create')}}</strong> <strong class="deep-blue-text font-weight-bold">{{$t('account')}}</strong></h3>
          <h3 class="mb-4 mt-4 font-weight-bold text-uppercase" v-if="isTalentApp"><strong class="deep-blue-text font-weight-bold">{{$t('answers_to_questionnaire_talent')}}</strong></h3>
          <h3 class="mb-4 mt-4 font-weight-bold text-uppercase" v-if="isVenteApp"><strong class="deep-blue-text font-weight-bold">{{$t('answers_to_questionnaire_talent')}}</strong></h3>
        </md-card-header>
        <md-card-content class="ml-4 mr-4">
          <div class="md-layout md-gutter">
            <div class="md-layout-item md-small-size-100">
              <md-field :class="getValidationClass('email')">
                <md-icon>email</md-icon>
                <label for="email">{{$t('your_email')}}</label>
                <md-input type="email" name="email" id="email" autocomplete="email" v-model="form.email" :disabled="sending" />
                <span class="md-error" v-if="!$v.form.email.required">{{$t('required.email')}}</span>
                <span class="md-error" v-else-if="!$v.form.email.email">{{$t('invalid.email')}}</span>
              </md-field>
            </div>
            <div class="md-layout-item md-small-size-100">
              <md-field :class="getValidationClass('password')">
                <md-icon>vpn_key</md-icon>
                <label for="password">{{$t('your_password')}}</label>
                <md-input type="password" name="password" id="password" v-model="form.password" :disabled="sending" />
                <span class="md-error" v-if="!$v.form.password.required">{{$t('required.password')}}</span>
                <span class="md-error" v-else-if="!$v.form.password.minlength">{{$t('invalid.password')}}</span>
              </md-field>
              <p class="pb-3 ml-1 small grey-text">{{$t('save_your_password')}}</p>
            </div>
          </div>

          <div class="md-layout md-gutter">
            <div class="md-layout-item md-small-size-100">
              <md-field :class="getValidationClass('firstName')">
                <md-icon>account_circle</md-icon>
                <label for="first-name">{{$t('your_first_name')}}</label>
                <md-input name="first-name" id="first-name" autocomplete="given-name" v-model="form.firstName" :disabled="sending" />
                <span class="md-error" v-if="!$v.form.firstName.required">{{$t('required.first_name')}}</span>
                <span class="md-error" v-else-if="!$v.form.firstName.minlength">{{$t('invalid.first_name')}}</span>
              </md-field>
            </div>
            <div class="md-layout-item md-small-size-100">
              <md-field :class="getValidationClass('lastName')">
                <md-icon>account_box</md-icon>
                <label for="last-name">{{$t('your_last_name')}}</label>
                <md-input name="last-name" id="last-name" autocomplete="family-name" v-model="form.lastName" :disabled="sending" />
                <span class="md-error" v-if="!$v.form.lastName.required">{{$t('required.last_name')}}</span>
                <span class="md-error" v-else-if="!$v.form.lastName.minlength">{{$t('invalid.last_name')}}</span>
              </md-field>
            </div>
          </div>

          <div class="md-layout md-gutter">
            <div class="md-layout-item md-small-size-100">
              <md-field :class="getValidationClass('country')">
                <md-icon>flag</md-icon>
                <label for="country">{{$t('your_country')}}</label>
                <md-select name="country" id="country" v-model="form.country" md-dense :disabled="sending">
                  <md-option v-for="(country, index) in arr_country" :key="index" :value="index">{{country}}</md-option>
                </md-select>
                <span class="md-error">{{$t('required.country')}}</span>
              </md-field>
            </div>
            <div class="md-layout-item md-small-size-100">
              <md-field :class="getValidationClass('civility')">
                <md-icon>wc</md-icon>
                <label for="civility">{{$t('civility')}}</label>
                <md-select name="civility" id="civility" v-model="form.civility" md-dense :disabled="sending">
                  <md-option value="Monsieur">{{$t('mr')}}</md-option>
                  <md-option value="Madame">{{$t('mrs')}}</md-option>
                </md-select>
                <span class="md-error">{{$t('required.civility')}}</span>
              </md-field>
            </div>
          </div>

          <md-field :class="getValidationClass('birthYear')">
            <md-icon>date_range</md-icon>
            <label for="birthyear">{{$t('your_birth_year')}}</label>
            <md-select name="birthYear" id="birthyear" v-model="form.birthYear" md-dense :disabled="sending">
              <md-option v-for="year in getRangeYear(1920)" :key="year" :value="year">{{year}}</md-option>
            </md-select>
            <span class="md-error">{{$t('required.birth_year')}}</span>
          </md-field>
        </md-card-content>
        <md-progress-bar md-mode="indeterminate" v-if="sending" />
        <div class="mt-0 mr-4 ml-4 mb-4" id="test">
          <p class="small grey-text terms-of-use"><md-checkbox v-model="terms_of_use" class="md-primary"></md-checkbox>{{$t('terms_of_conditions')}}.&nbsp;<a target="_blank" :href="termLink">{{$t('read_details')}}</a>.</p>
          <p class="small grey-text terms-of-use newsletter" v-if="show_newsletter"><md-checkbox v-model="accept_newsletter" class="md-primary"></md-checkbox>{{$t('accept_newsletter_model_comcolors')}}</p>
          <p v-if="showFormCode">
            <md-field class="md-fd">
              <label for="campaign-code">{{$t('code')}} :</label>
              <md-input name="campaign-code" id="campaign-code" v-model="campaign_code" :placeholder="$t('holder_type_code')" :disabled="sending" /><br />
              <span class="md-error" v-show="campaignCodeError" v-bind:style="campaignCodeError ? 'opacity: 1;' : 'opacity: 0;'">{{$t('your_code_is_invalid')}}</span>
            </md-field>
          </p>
          <div class="text-center mb-3">
              <btn :disabled="sending" type="submit" color="info" size="md" class="btn-rounded">{{$t('signup')}}</btn>
          </div>
          <p class="small grey-text" v-if="isTalentApp">{{$t('message_you_received_talent_pdf')}}</p>

        </div>
      </md-card>
      <md-snackbar :md-active.sync="userSaved">{{ lastUser }} {{$t('user_saved_with_success')}}</md-snackbar>
    </form>
  </div>
</template>

<script>
import axios from 'axios'
import { BASE_API } from '../helpers/base'
import { Btn } from 'mdbvue';
import { validationMixin } from 'vuelidate'
import { required, email, minLength, maxLength } from 'vuelidate/lib/validators'
import { getLoggedUser, isTalentApp, isVenteApp, isTalentOrVenteApp, hasCompleteAccount } from '../services/User.service'
import { getProductVente } from "../services/Questionnaire.service";
import { mapGetters, mapActions } from 'vuex'

export const validPassword = (value, component) => {
  if (!value) return false
  const hasMinLength = value.length >= 6
  const hasDigit = /\d/.test(value)
  const hasLetter = /[a-zA-Z]/.test(value)
  return hasMinLength && hasDigit && hasLetter
}

export default {
  name: 'Register',
  mixins: [validationMixin],
  data: () => ({
    form: {
      firstName: null,
      lastName: null,
      email: null,
      password: null,
      country: null,
      civility: null,
      birthYear: null
    },
    userSaved: false,
    sending: false,
    lastUser: null,
    arr_country: [],
    message: false,
    terms_of_use: false,
    accept_newsletter: false,
    campaign_code: '',
    contactId: -1,
    campaignCodeError: false,
    showFormCode: false,
    isVenteWithFreeQuestionnaire: false,
    isTalentApp: isTalentApp(),
    isVenteApp: isVenteApp(),
    isTalentOrVenteApp: isTalentOrVenteApp(),
    show_newsletter: isTalentOrVenteApp(),
    alertMessage: '',
    alertClass: '',
  }),
  validations: {
    form: {
      firstName: {
        required,
        minLength: minLength(1)
      },
      lastName: {
        required,
        minLength: minLength(1)
      },
      email: {
        required,
        email
      },
      password: {
        required,
        minLength: minLength(6),
        validPassword
      },
      country: {
        required
      },
      civility: {
        required
      },
      birthYear: {
        required
      }
    }
  },
  computed: {
    termLink() {
      return (this.$route.params.locale == 'fr' || this.$route.params.locale == 'qc' ? 'https://www.comcolors.com/fr/rgpd/' : 'https://www.comcolors.com/fr/rgpd/')
    }
  },
  methods: {
    ...mapActions(['setUserDetails']),
    getValidationClass (fieldName) {
      const field = this.$v.form[fieldName]

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }
    },
    clearForm () {
      this.$v.$reset()
      this.form.firstName = null
      this.form.lastName = null
      this.form.email = null
      this.form.password = null
      this.form.country = null
      this.form.civility = null
      this.form.birthYear = null
      this.terms_of_use = false
    },
    saveUser () {
      this.sending = true
      let origin = isTalentApp() ? 'talent' : null
      origin = isVenteApp() ? 'vente' : origin

      let data = {
        prenom: this.form.firstName,
        nom: this.form.lastName,
        email: this.form.email,
        password: this.form.password,
        pays: this.form.country,
        civilite: this.form.civility,
        annee_naissance: this.form.birthYear,
        origin: origin
      }
      if(isTalentOrVenteApp()){
        data.newsletter_talent = (this.accept_newsletter == true ? 1 : 0)
        data.campaign_code = this.campaign_code
        data.sib_id = this.contactId
      }

      if(this.terms_of_use == true && ((isTalentOrVenteApp() && this.campaign_code != '' && this.accept_newsletter == true) ||
        (isTalentOrVenteApp() && this.campaign_code == '') || (!isTalentOrVenteApp() && this.accept_newsletter == false))) {
        if(isTalentOrVenteApp() && this.campaign_code != ''){
          let code = {
            code: this.campaign_code
          }
          this.$store.dispatch('checkCode', code).then((resp) => {
            if (parseInt(resp.data.contact_id) > 0) {
              this.contactId = resp.data.contact_id
              data.sib_id = this.contactId
              this.registerUser(data)
            } else {
              this.sending = false
              this.message = true
              this.alertClass = 'alert-danger'
              this.alertMessage = this.$t('your_code_is_invalid')
              this.campaignCodeError = true
              this.backToTop();
              this.setTimeOut();
            }
          })
        }else{
          this.registerUser(data)
        }
      }else{
        this.sending = false
        this.message = true
        this.alertClass = 'alert-danger'
        this.alertMessage = this.$t('terms_of_use_error_message')
        if (this.terms_of_use == false && (isTalentOrVenteApp() && this.campaign_code != '' && this.accept_newsletter == false)) {
          this.alertMessage = this.$t('terms_of_use_error_message')
          this.alertMessage += '<br>'+this.$t('alert_not_be_able_communicate_your_talents_pdf')
        } else if (this.terms_of_use == true && (isTalentOrVenteApp() && this.campaign_code != '' && this.accept_newsletter == false)) {
          this.alertMessage = this.$t('alert_not_be_able_communicate_your_talents_pdf')
        }
        this.backToTop();
        this.setTimeOut();
      }
    },
    registerUser (data) {
      this.$store.dispatch('register', data).then((resp) => {
        if (resp.data.status_code === 200) {
          const {email, password} = data
          this.$store.dispatch('login', {email, password}).then((resp) => {
            this.sending = false
            const userId = resp.data.user_info.id
            getLoggedUser(userId).then(response => {
              this.setUserDetails(response.data.user_info);
            }).catch(error => {
              this.$store.dispatch('logout');
              console.log(error);
            })

            if (hasCompleteAccount(resp.data.user_info) || this.isVenteWithFreeQuestionnaire) {
              if (isVenteApp()) {
                this.$router.push({name:'Questionnaire'});
              } else {
                this.$router.push({name:'QuestionnaireInstructions'});
              }
            } else {
              this.$router.push({name: 'Account'});
            }
          })
        } else {
          this.sending = false
          this.message = true
          this.alertClass = 'alert-danger'
          this.alertMessage = this.$t('email_already_exist')
          this.backToTop();
          this.$router.push('register')
          this.setTimeOut();
        }
      })
    },
    validateUser () {
      this.$v.$touch()

      if (!this.$v.$invalid) {
        this.saveUser()
      }
    },
    arr_pays(){
      axios.get(`${BASE_API}/countries`)
      .then(response => {
        this.arr_country = response.data.arr_pays
        this.form.country = 'fr';
      })
    },
    getRangeYear(start){
      const stop = (new Date()).getFullYear();
      return new Array(stop-start + 1).fill(start).map((n,i)=>n+i);
    },
    setCampaignCode(){
      if(isTalentOrVenteApp()) {
        // ?utm_campaign=CA%2B33%25
        // ?utm_campaign=talents-comcolors
        let searchParams = new URLSearchParams(window.location.search)
        if (searchParams.has('utm_campaign')) {
          let value = searchParams.get('utm_campaign')
          // remove injecton code example ?utm_campaign=5 AND 1%3D2 UNION SELECT password,username FROM users WHERE usertype%3D"admin"
          value = value.replace('SELECT', '')
          value = value.replace('WHERE', '')
          value = value.replace('select', '')
          value = value.replace('where', '')
          value = value.replace('script', '')

          this.campaign_code = value;
        }
      }
    },
    trackPageToFb(){
      if(isTalentOrVenteApp()){
        if (typeof fbq != "undefined") {
          fbq('track', 'AddToCart');
          console.log('Fire facebook pixel AddToCart');
        }
      }
    },
    setTimeOut(){
      window.setTimeout(function(){
        $('.alert').fadeIn(function(){
            setTimeout(function(){
                $(".alert").fadeOut(500, function(){
                    $(this).hide();
                });
            }, 4000)
        })
      });
    },
    backToTop(){
      $('html,body').stop().animate({
          scrollTop: 0
      }, 'slow', 'swing');
    },
    initCmpt() {
      this.showFormCode = isTalentApp() ? true : false;
      if (isVenteApp()) {
        getProductVente().then(response => {
          const resData = response.data
          this.showFormCode = !resData.is_free;
          this.isVenteWithFreeQuestionnaire = !this.showFormCode ? true : false;
        }).catch(error => {
          console.log(error.response);
        })
      }
    }
  },
  components: {
      Btn
  },
  mounted() {
    this.initCmpt();
    this.arr_pays();
    this.setCampaignCode();
    this.trackPageToFb();
  }
}
</script>

<style scoped>
.md-progress-bar {
position: absolute;
top: 0;
right: 0;
left: 0;
}
@media (max-width: 425px){
.md-card-content{
margin: 0 !important;
}
}
.newsletter {
  justify-content: left;
  align-items: normal;
}
.terms-of-use {
  float:left;
  margin-left: 4.8%;
}
.md-fd {
  display: block;
}
.md-fd:after, .md-fd:before {
  display: none;
}
.md-fd input {
  height: 30px;
  padding-left: 10px;
  display: inline-block;
  border-bottom: 1px solid #9e9e9e;
  background: none;
  font-size: 16px;
  width: 42%;
  text-align: center;
}
.md-fd input::placeholder {
  font-size: 14px;
}
.md-fd label {
  position: relative;
  top:0;
  opacity: 1;
  color: rgba(0, 0, 0, 0.87);
}
.md-fd .md-error {
  display: inline-block !important;
  color: red;
  text-align: center;
  position: inherit;
}
</style>



// WEBPACK FOOTER //
// src/components/Register.vue